export const permissions = {
  withdrawal: {
    admin: ['write', 'read'],
    user: ['read'],
  },
  user: {
    admin: ['write', 'read'],
    user: ['read'],
  },
  recipient: {
    admin: ['write', 'read'],
    user: ['read'],
  },
  recipientBankAccount: {
    admin: ['write', 'read'],
    user: ['read'],
  },
};
